import * as React from 'react';
import { connect } from 'react-redux';

import { clickedOdds } from '../actions/odds';

import {
    getRankingsByMatchId,
    getTeamNamesByMatchId,
    getServingPlayerByMatchId,
    getGamePointsByMatchId,
    getPlayerIdsByMatchId,
    getPlayerUidsByMatchId,
    getPeriodByMatchId,
    getTeamAbbreviationNamesByMatchId,
    getWinnerDeterminedByMatchId,
} from '../reducers/matches';

import { getPointWinnerOddsByMatchId,
    getSetWinnerOddsByMatchId,
    getGameWinnerOddsByMatchId } from '../reducers/odds';

import { getMatchIdByChannelId } from '../reducers/timings';
import { getRankAccordingToPlayerId } from '../reducers/statsRanking';
import { getStaticText } from '../reducers/staticTexts';
import { getTranslations } from '../reducers/translations';
import { getBaseUrl, getClientId, getOddType } from '../reducers/config';
import { getActiveChannelId, getBetstopByMatchId } from '../reducers/gui';


import PlayerAndOddsPresentation from '../presentations/PlayerAndOdds/PlayerAndOddsPresentation';

const mapStateToProps = (state: any, ownProps: { channelId?: number } ) => {
    
    const channelId:number = ownProps.channelId ? ownProps.channelId : state.activeChannelId;
    const matchId = getMatchIdByChannelId(state, channelId); 
    const oddType = getOddType(state);

    return {
        baseUrl: getBaseUrl(state),
        clientid: getClientId(state),
        activeChannelId: getActiveChannelId(state),
        ranks: getRankingsByMatchId(state, matchId),
        ranksByPlayerIds: getRankAccordingToPlayerId(state),
        playerNames: getTeamNamesByMatchId(state, matchId),
        playerAbbreviationNames: getTeamAbbreviationNamesByMatchId(state, matchId),
        servingPlayer: getServingPlayerByMatchId(state, matchId),
        gamePoints: getGamePointsByMatchId(state, matchId),
        playerids: getPlayerIdsByMatchId(state, matchId),
        playerUids: getPlayerUidsByMatchId(state, matchId),
        period: getPeriodByMatchId(state, matchId),
        staticTexts: getStaticText(state),
        translations: getTranslations(state),
        pointWinnerOdds: getPointWinnerOddsByMatchId(state, matchId, oddType),
        setWinnerOdds: getSetWinnerOddsByMatchId(state, matchId, oddType),
        gameWinnerOdds: getGameWinnerOddsByMatchId(state, matchId, oddType),
        betstop: getBetstopByMatchId(state, matchId),
        winnerDetermined: getWinnerDeterminedByMatchId(state, matchId),
        oddType: oddType,
        matchId: matchId,
    }
};

const mapDispatchToProps = (dispatch:Function) => ({
    clickedOdds: (data:any) => dispatch(clickedOdds(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(PlayerAndOddsPresentation);
